import React, { FC, useEffect } from "react";

import { KpkApiHitConnectionMode, KpkApiHitHitType } from "@keepeek/api-client";
import { LS_KC_SESSION_ID, useStats } from "@keepeek/commons";
import { useRouter } from "next/router";

import { useInitConfig } from "../../providers/config/hooks/init";
import { mapPathNameToPageName } from "../../providers/page/utils";
import AuthProvider from "./AuthProvider";
import { PageName } from "./utils";

const SHARE_SESSION_ID = "SHARE_SESSION_ID";

const ConditionalAuth: FC<React.PropsWithChildren<unknown>> = function ({ children }) {
  const { initConfig } = useInitConfig();
  const { sendHit } = useStats({ ip: initConfig?.clientIp, isPublicShare: true });

  const { query, pathname } = useRouter();
  const pageName = mapPathNameToPageName(pathname);
  const todayDate = new Date();
  const todayDateInString = `${todayDate.getFullYear()}${
    todayDate.getMonth() + 1
  }${todayDate.getDay()}`;
  const valueInlocalStorage =
    typeof query.tokenId === "string"
      ? query.tokenId + todayDateInString
      : Array.isArray(query.tokenId)
      ? query.tokenId[0] + todayDateInString
      : SHARE_SESSION_ID;

  useEffect(() => {
    const sendStat = async () => {
      let result = false;
      try {
        result = await sendHit({
          connection: {
            mode: KpkApiHitConnectionMode.Anonymous,
            success: true,
          },
          type: KpkApiHitHitType.Connection,
        });
        console.debug(`[sendConnectionHit-basket] ${result ? "success" : "failed"}`);
      } catch (err) {
        console.error(`[sendConnectionHit-basket] error : `, err);
      } finally {
        if (result) {
          localStorage.setItem(LS_KC_SESSION_ID, valueInlocalStorage);
        }
      }
    };
    if (pageName !== PageName.SHARE_SEARCH_PAGE) {
      return;
    }
    const lsSessionId = localStorage.getItem(LS_KC_SESSION_ID);

    if (valueInlocalStorage === lsSessionId) {
      console.debug("[sendConnectionHit-basket] won't send because this sessionId has already hit");
      return;
    }

    sendStat();
  }, [pageName, sendHit, valueInlocalStorage]);

  if (pageName !== PageName.SHARE_SEARCH_PAGE && pageName !== PageName.SHARE_ELEMENT_PAGE) {
    return <AuthProvider>{children}</AuthProvider>;
  }
  return <>{children}</>;
};

export default ConditionalAuth;
